export function isUUID(v?: string) {
  return !!v && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(v);
}

export function parsePedidoCode(code: string) {
  // aceita: "P2510060051-1", "#PEDIDO2510060051", "PEDIDO2500022", etc.
  const s = code.replace(/^#/, '').toUpperCase();
  const m = s.match(/^P(?:ED(?:IDO)?)?-?(\d+)(?:-(\d+))?$/i);
  if (!m) return null;
  
  const numero = parseInt(m[1], 10);
  const itemSeq = m[2] ? parseInt(m[2], 10) : null;
  
  if (!Number.isFinite(numero)) return null;
  
  // Validação básica de formato (7 ou 10 dígitos)
  const numStr = numero.toString();
  if (numStr.length !== 7 && numStr.length !== 10) return null;
  
  return { numero, itemSeq };
}
